export enum UserClaimFlag {
	BrandRead = 1 << 0,
	BrandWrite = 1 << 1,
	BrandDelete = 1 << 2,
	VideoRead = 1 << 3,
	VideoWrite = 1 << 4,
	VideoDelete = 1 << 5,
	System = 1 << 6,
	User = 1 << 7,
}

export interface User {
	name: string;
	email: string;
	claimFlag: UserClaimFlag;
	enabled: boolean;
}

export interface UserResponse extends User {
	id: number;
}

export default User;
